export class MaterialCache {
    data = {};

    set(id:string, value: any) {
        this.data[id] = value;
    }

    get(id: string) {
        return this.data[id];
    }
}